/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { IExercise, IMuscleGroup } from '../domains/Exercise';
import { IPaginatedResponse } from '../domains/Pagination';
import { api } from './api';

interface IGetExercisesParams {
  page?: number;
  limit?: number;
  search?: string;
  muscle_group_id?: string;
}

interface ISaveDefaultExercisePayload {
  name: string;
  muscle_groups: IExercise['muscle_groups'];
  description?: string;
}

// Contraparte administrativa de ExercisesService: aqui `is_custom` do
// item não é relevante (todo item já É a biblioteca padrão) e o dono é
// sempre a plataforma, não uma academia -- por isso um service próprio
// em vez de mexer no existente, que é gym-escopado.
class AdminExercisesService {
  private apiService = api;

  public async getMuscleGroups() {
    return this.apiService.get<IMuscleGroup[]>('exercises/muscle_groups');
  }

  public async getExercises(params: IGetExercisesParams = {}) {
    return this.apiService.get<IPaginatedResponse<IExercise>>(
      'admin/exercises',
      { params },
    );
  }

  public async getExerciseById(id: string) {
    return this.apiService.get<IExercise>(`admin/exercises/${id}`);
  }

  public async createExercise(data: ISaveDefaultExercisePayload) {
    return this.apiService.post<IExercise>('admin/exercises', {
      name: data.name,
      muscle_groups: data.muscle_groups,
      description: data.description,
    });
  }

  public async updateExercise(id: string, data: ISaveDefaultExercisePayload) {
    return this.apiService.put<IExercise>(`admin/exercises/${id}`, {
      name: data.name,
      muscle_groups: data.muscle_groups,
      description: data.description,
    });
  }

  public async removeExercise(id: string) {
    return this.apiService.delete(`admin/exercises/${id}`);
  }
}

export { AdminExercisesService };
